import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

const ViewHostAsset = ({ formData = {} }) => {
  const [formState, setFormState] = useState({});

  useEffect(() => {
    setFormState({
      Description: formData?.Description || "",
      locationname: formData?.locationname || "",
      Department: formData?.Department || "",
      Manufacturer: formData?.Manufacturer || "",
      ModelNo: formData?.ModelNo || "",
      Capacity: formData?.Capacity || "",
      Sparescount: formData?.Sparescount || "",
      Remarks: formData?.Remarks || "",
      Code: formData?.Code || "",
    });
  }, [formData]);

  return (
    <div>
      <style>
        {`
        @media (max-width: 576px) {
          #offcanvasRightViewHostAsset {
            width: 90% !important;
          }
        }
        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightViewHostAsset {
            width: 55% !important;
          }
        }
        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightViewHostAsset {
            width: 35% !important;
          }
        }
        @media (min-width: 1441px) {
          #offcanvasRightViewHostAsset {
            width: 30% !important;
          }
        }
      `}
      </style>

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightViewHostAsset"
        aria-labelledby="offcanvasRightLabel"
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">View AHU Machine</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>

        <hr className="m-0" />
        <div className="offcanvas-body">
          <div className="row">
            <div className="col-6 mb-3">
              <label className="form-label">AHU Code
              </label>
              <input
                type="text"
                className="form-control"
                value={formState.Code}
                disabled
              />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">AHU Description</label>
              <input
                type="text"
                className="form-control"
                value={formState.Description}
                disabled
              />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Area/Zone Served</label>
              <input
                type="text"
                className="form-control"
                value={formState.locationname}
                disabled
              />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Department</label>
              <input
                type="text"
                className="form-control"
                value={formState.Department}
                disabled
              />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Manufacturer</label>
              <input
                type="text"
                className="form-control"
                value={formState.Manufacturer}
                disabled
              />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Model Number</label>
              <input
                type="text"
                className="form-control"
                value={formState.ModelNo}
                disabled
              />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Capacity (CFM)</label>
              <input
                type="number"
                className="form-control"
                value={formState.Capacity}
                disabled
              />
            </div>
            <div className="col-6 mb-3">
              <label className="form-label">Number of Filters</label>
              <input
                type="number"
                className="form-control"
                value={formState.Sparescount}
                disabled
              />
            </div>

            <div className="col-12 mb-3">
              <label className="form-label">Remarks</label>
              <textarea
                className="form-control"
                rows="2"
                value={formState.Remarks}
                disabled
              ></textarea>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="offcanvas"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ViewHostAsset.propTypes = {
  formData: PropTypes.object,
};

export default ViewHostAsset;
